module.exports = __webpack_public_path__ + "img/rect1.8df9249e.png";